import type { ApiRentalDealItem } from 'src/types/rental';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from 'src/utils/axios';

import { QueryKeys } from './QueryKeys';

/**
 * Deploy-on-Pay (rental-clock v2.1): the escrow contract is deployed only when the
 * renter proceeds to payment, so the pay modal calls this first and then sends
 * approve+pay to the returned contract in the same session. Idempotent on the api
 * side — an already-deployed deal just comes back with its on-chain state.
 */
export function usePrepareRentalPayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dealId: string) => {
      const response = await axios.post<ApiRentalDealItem>(
        `/buyer/rental-deals/${dealId}/prepare-payment`
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.rentalDeals() });
    },
  });
}
